import React from "react";
import { Helmet } from "react-helmet";
import ScholarshipHeaderSection from "./components/ScholarshipHeaderSection";
import ScholarshipMetricsSection from "./components/ScholarshipMetricsSection";
import ScholarshipProcessSection from "./components/ScholarshipProcessSection";
import ScholarshipSpotlightSection from "./components/ScholarshipSpotlightSection";
import ScholarshipOpportunitySection from "./components/ScholarshipOpportunitySection";
import ScholarshipFinalCtaSection from "./components/ScholarshipFinalCtaSection";
import SiteFooter from "../../components/layout/SiteFooter";

const Scholarships = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | Scholarships</title>
        <meta
          name="description"
          content="Utiva scholarship partnerships help people overcome financial barriers and enter practical technology learning pathways."
        />
      </Helmet>

      <ScholarshipHeaderSection />

      <ScholarshipMetricsSection />

      <ScholarshipProcessSection />

      <ScholarshipSpotlightSection />

      <ScholarshipOpportunitySection />

      <ScholarshipFinalCtaSection />

      <SiteFooter />
    </div>
  );
};

export default Scholarships;
